<div class="swiper" #swiperRef>
  <div class="swiper-wrapper">
    @for (item of data; track item.title) {
    <div class="swiper-slide">
      <!-- Dynamic Templates -->
      @switch (type) { @case ('reviewSlider') {

      <div class="customer_say_box homeconmman_say_box">
        <div class="row">
          <!-- Name + Rating -->
          <div class="col-9 col-lg-9">
            <h3 class="regular_font font_weight_400 color_4">
              {{ item.name }}
            </h3>

            <div class="starcolur">★ ★ ★ ★ ★</div>
          </div>

          <!-- Image -->
          <div class="col-3 col-lg-3">
            <img [src]="item.img" class="cardimagge" alt="user" width="56" height="56" />
          </div>

          <!-- Content -->
          <div class="col-lg-12">
            <p class="color_4 mt-2">{{ item.content }}</p>
          </div>
        </div>
      </div>

      } 
        @case ('strssslides') {
      <div class="service_therapy_box commonservuice strsstherotpy depresionslidehight depresi">
        <!-- <div class="circle_box">&#64;</div> -->
        <h3>{{item.title}}</h3>
        <p>{{item.description}}</p>
      </div>
      }
      @case ('slides') {
      <div class="service_therapy_box commonservuice  depresionslidehight depresi">
        <!-- <div class="circle_box">&#64;</div> -->
        <h3>{{item.title}}</h3>
        <p>{{item.description}}</p>
      </div>
      } @case ('aboutsslides') {

      <div class="service_therapy_box_about commonservuice aboytsslidehight">
        <div class="row">
          <div class="col-2 col-lg-2">
            <img [src]="data[selectedIndex]?.img" class="aboutsimg" width="48" height="48" />
          </div>

          <div class="col-10 col-lg-10 mt-2">
            <h3>{{ data[selectedIndex]?.title }}</h3>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-12">
            <p>{{ data[selectedIndex]?.description }}</p>
          </div>
        </div>
      </div>

      }
      
      @case ('upcomingappointment') {

   
      <div class="row">

                        <div class="col-4">
                            <div class="insite_img_container allsliderimg">
                                 @if (item.HCP.HCPImage != null && item.HCP.HCPImage != '') {
                           
                                        <img src="{{drImageBaseUrl+item.HCP.HCPImage}}" class="inhitsimg" width="120" height="150"
                                             alt="dr images">
                                    }
                                    @else {
                                        <img src="img/default-user.png" class="inhitsimg" alt="nainika makhija" width="120" height="150" />
                                    }
                            </div>
                           
                       
                       
                        </div>

                        <div class="col-8 session-info">
                            <h3 class="semibold font_weight_500 couler_4">{{item.HCP.HCPName}}</h3>
                            <p class="regular_font font_weight_400 couler_4">{{item.HCP.HCPType}}
                            </p>
                            <p class="regular_font font_weight_400 couler_4">
                                {{item.HCP.experience}}</p>
                            <div class="datetimeback">
                                <p class="regular_fontfont_weight_500 couler_4">Date :<span
                                        class="semibold font_weight_500 color_4 ">{{item.approved_start_time*1000|date:'MMM d, y'}}</span></p>
                                <p class="regular_fontfont_weight_500 font_weight_500 couler_4">
                                    Time: <span
                                        class="semibold font_weight_500 color_4">{{item.approved_start_time*1000|date:'h:mm a'}}</span></p>
                            </div>
                           
                        </div>
          

                    </div>

               
    


}

      @case ('ptsdslides') {
      <div class="conditionssec_depression commomclassa commomclassa psdservice thirdbg">
        <!-- <div class="circle_box">&#64;</div> -->
        <h3>{{item.title}}</h3>
        <p>{{item.description}}</p>
      </div>
      } @case ('ppdSymptoms') { @for (item of item.items; track $index) {

      <div class="row">
        <!-- Image -->
        <div class="col-2 col-lg-2 mt-3">
          <img [src]="item.img" class="imagecoorectsign_anger_ppd" width="50" height="50" />
        </div>

        <!-- Text -->
        <div class="col-10 col-lg-10 mt-3">
          <p class="commonslidep">{{ item.text }}</p>
        </div>
      </div>

      } } @case ('angerslides') {
      <div
        class="service_therapy_box commonservuice service_therapy_box_angry_issue_height angerservice_therapy_box"
      >
        <!-- <div class="circle_box">&#64;</div> -->
        <h3>{{item.title}}</h3>
        <p>{{item.description}}</p>
      </div>
      } @case ('typesOfCouplesTherapy') {
      <div class="therapy_box_cuple">
        <img [src]="item.img" alt="Teens Therapy" class="offset-1" width="96" height="96" />

        <div class="content_box_sec_2_cuple">
          <h3 class="text-center">{{item.title}}</h3>
          <p class="text-center">{{item.content}}</p>
        </div>
      </div>
      } @case ('healthmind') {
      <a [href]="item.url" style="text-decoration: none;">
        <div class="therapy_box therapy_box_home_mobile text-center">
          <!-- <img [src]="item.img" alt="therapy" width="300" height="402" loading="lazy"/> -->
           <img [src]="item.img"  width="300" height="402" sizes="(max-width: 768px) 100vw, 300px" loading="lazy"alt="therapy" class="responsive-img"/>

          <div class="content_box_sec_2">
            <h3 class="text-center">{{item.title}}</h3>
            <p class="text-center">{{item.content}}</p>
          </div>
        </div>
      </a>
      } @case ('review') {
      <div class="customer_say_box leqiya_say_box">
        <div class="row">
          <div class="col-9 col-lg-9">
            <h3>{{item.name}}</h3>
            <div class="starcolur">&#9733; &#9733; &#9733; &#9733; &#9733;</div>
          </div>
          <div class="col-3 col-lg-3">
            <img src="{{item.img}}" class="cardimagge" alt="man" width="56" height="56" />
          </div>
          <div class="col-lg-12">
            <p>{{item.content}}</p>
          </div>
        </div>
      </div>
      } @case ('anxietySlides') { @for (item of item.items; track $index) {
      <div class="row mtd20">
        <div class="col-2">
          <img [src]="item.img" class="imagecoorectsign" width="50" height="50" />
        </div>

        <div  class="col-10 col-lg-10 d-flex align-items-center">
          <p class="commonslidep mb-0">{{ item.text }}</p>
         
        </div>
      </div>
      } } @case ('angerSymptoms') {

      <div class="row mb-3">
        <!-- Image -->
        <div class="col-2 col-lg-2">
          <img [src]="item.img" class="imagecoorectsign_anger" width="50" height="50" />
        </div>

        <!-- Content -->
        <div class="col-10 col-lg-10">
          <h3>{{ item.title }}</h3>

          <p>{{ item.description }}</p>
        </div>
      </div>

      }
       @case ('Slides') {
      <div class="service_anaxy_box service_therapy_box anixityservice_anaxy_box anixitslide">
        <!-- Title -->
        <h3>{{ item.title }}</h3>

        <!-- Description -->
        <p>{{ item.description }}</p>

        <!-- List -->

        <ul>
          @for (l of item.list; track $index) {
          <li>{{ l.listName }}</li>
          }
        </ul>
      </div>

       }
        @case ('careerslides') {
      <div class="career_page_box commonservuice">
                        <div class="row">
                            <div class="col-2 col-lg-3">
                                <img src="{{item.img}} " class="career_circle" alt="slideimage">
                            </div>
                            <div class="col-10 col-lg-9">
                               
                                <h3>{{item.title}}</h3>
                                <p>
                                   {{item.description}}
                                </p> 
                            </div>
                            
                        </div>
                         
                      </div>
                   
                 
       }
      @case ('problemSolution') { @for (s of item.arr1; track $index) {

      <div class="proble_and_solution commomclassa thirdbg mb-3">
        <!-- Button -->
        <div class="row">
          <div class="col-lg-12">
            <button class="{{ s.addclass }}">{{ s.problem }}</button>
          </div>
        </div>

        <!-- Description -->
        <div class="row">
          <div class="col-lg-12">
            <p>{{ s.describe }}</p>
          </div>
        </div>
      </div>

      } } @case ('ppdslides') {
      <div
        class="service_therapy_box commonservuice service_therapy_box_ppd_height ppdservice_box"
      >
        <!-- Title -->
        <h3>{{ item.title }}</h3>

        <!-- Description -->
        <p>{{ item.description }}</p>

        <!-- List -->

        <ul>
          @for (l of item.list; track $index) {
          <li>{{ l.listName }}</li>
          }
        </ul>
      </div>

      } @case ('Slidesaddiction') {
      <div class="service_therapy_box_addiction_height service_therapy_box  commonservuice addiication">
        <!-- Title -->
        <h3>{{ item.title }}</h3>

        <!-- Description -->
        <p>{{ item.description }}</p>

        <!-- List -->

        <ul>
          @for (l of item.list; track $index) {
          <li>{{ l.listName }}</li>
          }
        </ul>
      </div>

      }
       @case ('coupleTherapy') {

  <div class="maincontainer mb3">

    <div class="pricecardcontainer">

      <!-- Session -->
      <h4>
        {{item.session}} {{item.session == 1 ? 'Session' : 'Sessions'}}
      </h4>

      <div class="borderwidth"></div>

      <!-- Offer Price -->
      @if (item.offerPrice == 2500) {
        <p class="offerprice">
          <span class="pricecolur">₹ {{item.offerPrice}}</span>
        </p>
      } @else {
        <p class="offerprice">
          <del class="pricecolur">₹ {{item.offerPrice}}</del> 
          <span class="offerpricepercentage offerpricepercentageblue">
            {{item.discount}}% OFF
          </span>
        </p>
      }

      <!-- Validity -->
      <p class="validititext">
        Validity: 
        {{item.validity}} 
        {{ item.session == 1 ? 'Week' : (item.session == 3 ? 'Month' : 'Months') }}
      </p>

      <!-- Final Price -->
      <div class="commoncontainer bluecontainer">
        <p class="pricetext">₹ {{item.actualPrice}}</p>

        @if (item.persession) {
          <p class="persessionprice">
            (₹{{item.persession}} / Session)
          </p>
        }
      </div>

    </div>

    <!-- BUTTON -->
    <button 
     href="/book-package" 
      type="button"
      class="packagebookcardbtn bluebtnbg color_4"
      (click)="bookPackage(item)">
      {{item.btn}}
    </button>

  </div>

}
@case ('expertArray') {

  <div class="metalhealthcardcontainer">
    <div class="row">

      <!-- IMAGE -->
      <div class="col-4 col-lg-4">
        <img 
          [src]="item.img" 
          width="120"
          height="140"
          class="expertimg" 
          [alt]="item.tag" 
          [title]="item.title"
        />

        <div class="expert_experience_box">
          {{ item.experience }}
        </div>
      </div>

      <!-- CONTENT -->
      <div class="col-8 col-lg-8">
        <h3>{{ item.drName }}</h3>

        <p>
          <img [src]="item.icon" style="display:inline;" width="16" height="16" />
          <span>{{ item.expert }}</span>
        </p>

        <div class="starcolur">
          &#9733; &#9733; &#9733; &#9733; &#9733;
        </div>

        <!-- BUTTON -->
        <button 
          class="expertenquarybtn Poppins-Medium"
          (click)="onExpertClick(item)">
          {{ item.btn }}
        </button>
      </div>

    </div>
  </div>

}
      
      @case ('slices') {

      <div class="service_anaxy_box service_therapy_box service_boxnew">
        <!-- Title -->
        <h3>{{ item.title }}</h3>

        <!-- Description -->
        <p>{{ item.description }}</p>

        <!-- List -->

        <ul>
          @for (l of item.list; track $index) {
          <li>{{ l.listName }}</li>
          }
        </ul>
      </div>

      } 
      @case ('ocdBehaviours') { @for (item of item.items; track $index) {
      <div class="row mtd20">
        <div class="col-2">
          <img [src]="item.img" class="imagecoorectsign" width="50" height="50" />
        </div>

        <div  class="col-10 col-lg-10 d-flex align-items-center">
          <p class="commonslidep mb-0">{{ item.text }}</p>
        </div>
      </div>
      } } @case ('addictionSymptoms') { @for (item of item.items; track $index)
      {

      <div class="row mtm20 mt-3">
        <!-- Image -->
        <div class="col-2 col-lg-2">
          <img [src]="item.img" class="imagecoorectsign" width="50" height="50" />
        </div>

        <!-- Text -->
        <div class="col-10 col-lg-10 d-flex align-items-center">
          <p class="commonslidep mb-0">{{ item.text }}</p>
        </div>
      </div>

      } } @case ('symptomsOfOcd') { @for (item of item.items; track $index) {
      <div class="row mtd20">
        <div class="col-2">
          <img [src]="item.img" class="imagecoorectsign" width="50" height="50" />
        </div>

        <div  class="col-10 col-lg-10 d-flex align-items-center">
          <p class="commonslidep mb-0">{{ item.text }}</p>
        </div>
      </div>
      } } 
      @case ('TypesOfAngerIssues') {

      <div class="commomclassa thirdbg">
        <h3>{{item.title}}</h3>
        <p >{{item.description}}</p>
      </div>
      }
      @case ('addictionSlides') {

      <div class="commomclassa thirdbg">
        <h3>{{item.title}}</h3>
        <p >{{item.description}}</p>
      </div>
      } @case ('benefits') { @for (item of item.items; track $index) {
      <div class="row mtd20">
        <div class="col-2">
          <img [src]="item.img" class="imagecoorectsign" width="50" height="50" />
        </div>

        <div class="col-10">
          <p>{{ item.description }}</p>
        </div>
      </div>
      } } @case ('therapy') {
      <div class="service_therapy_box commonservuice depresionslidehight depresi">
        <!-- Title -->
        <div class="row">
          <div class="col-lg-12">
            <h3>{{ item.title }}</h3>
          </div>
        </div>

        <!-- Points -->

        <div class="row mt-2">
          <div class="col-1 position-relative">
            <div class="dotbox_depression"></div>
          </div>

          <div  class="col-10 col-lg-11 d-flex align-items-center">
            <p class="commonslidep mb-0">{{ item.points }}</p>
          </div>
        </div>
      </div>

      } @case ('symptomsOfDepressive') { @for (item of item.items; track $index)
      {

      <div class="row mtd20">
        <!-- Image -->
        <div class="col-2">
          <img [src]="item.img" class="imagecoorectsign" width="50" height="50" />
        </div>

        <!-- Text -->
        <div class="col-10 col-lg-10 d-flex align-items-center">
          <p class="commonslidep mb-0">{{ item.text }}</p>
        </div>
      </div>

      } } @case ('symptomsOfManic') { @for (item of item.items; track $index) {

      <div class="row mtd20">
        <!-- Image -->
        <div class="col-2">
          <img [src]="item.img" class="imagecoorectsign" width="50" height="50" />
        </div>

        <!-- Text -->
        <div  class="col-10 col-lg-10 d-flex align-items-center">
          <p class="commonslidep mb-0">{{ item.text }}</p>
        </div>
      </div>

      } } @case ('symptomsOfSleep') { @for (item of item.items; track $index) {

      <div class="row mtd20">
        <!-- Image -->
        <div class="col-2">
          <img [src]="item.img" class="imagecoorectsign" width="50" height="50" />
        </div>

        <!-- Text -->
        <div  class="col-10 col-lg-10 d-flex align-items-center">
          <p class="commonslidep mb-0">{{ item.title }}</p>
        </div>
      </div>

      } } @case ('sleepCauses') { @for (item of item.items; track $index) {

      <div class="row mt-3">
        <!-- Image -->
        <div class="col-2">
          <img [src]="item.img" class="imagecoorectsign" width="50" height="50" />
        </div>

        <!-- Content -->
        <div class="col-10">
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>
        </div>
      </div>

      } } @case ('ppdSymptoms') { @for (item of item.items; track $index) {

      <div class="row">
        <!-- Image -->
        <div class="col-2 col-lg-2 mt-3">
          <img [src]="item.img" class="imagecoorectsign_anger_ppd" width="50" height="50" />
        </div>

        <!-- Text -->
        <div  class="col-10 col-lg-10 d-flex align-items-center">
          <p class="commonslidep">{{ item.text }}</p>
        </div>
      </div>

      } } @case ('physicalSymptoms') { @for (item of item.items; track $index) {

      <div class="row mtd20">
        <!-- Image -->
        <div class="col-2 col-lg-2">
          <img [src]="item.img" class="imagecoorectsign" width="50" height="50" />
        </div>

        <!-- Text -->
        <div  class="col-10 col-lg-10 d-flex align-items-center">
          <p class="commonslidep">{{ item.text }}</p>
        </div>
      </div>

      } } @case ('ppdSymptoms') { @for (item of item.items; track $index) {

      <div class="row mtm20">
        <!-- Image -->
        <div class="col-2 col-lg-2">
          <img [src]="item.img" class="imagecoorectsign" width="50" height="50" />
        </div>

        <!-- Text -->
        <div  class="col-10 col-lg-10 d-flex align-items-center">
          <p class="commonslidep">{{ item.text }}</p>
        </div>
      </div>

      } }
       @case ('depressionslide') { @for (item of item.items; track $index) {
      <div class="row mtd20">
        <div class="col-2">
          <img [src]="item.img" class="imagecoorectsign" width="50" height="50" />
        </div>

        <div class="col-10 col-lg-10 d-flex align-items-center">
          <p class="commonslidep mb-0">{{ item.text }}</p>
        </div>
        
      </div>
      } } @case ('service') {
      <div class="service_therapy_box commonservuice commonservuice">
        <h3>{{item.title}}</h3>
        <p>{{item.description}}</p>
      </div>
      } @case ('ocdTherapies') {
      <div class="service_therapy_box commomclassa thirdbg">
        <h3>{{item.title}}</h3>
        <p>{{item.description}}</p>
      </div>
      } @case ('ourApproach') {
      <img [src]="item.img" alt="Teens Therapy" class="imgteen" width="320" height="220" />

      <div class="lgbqt_contetent_box_2">
        <h3 class="text-center">{{item.title}}</h3>
        <p class="text-center">{{item.description}}</p>
      </div>
      } @default {
      <div>
        <h3>{{item.title}}</h3>
      </div>
      } }
    </div>
    }
  </div>

  <div class="swiper-pagination"></div>

  @if (type === 'expert') {
  <div class="swiper-button-next"></div>
  <div class="swiper-button-prev"></div>
  }
</div>
